<div class="light-blue-bg my-0 d-flex align-items-center">
<div class="container">
    <div class="row d-flex align-items-center">
        <div class="col-md-4 col-12 mb-1 mt-5 my-md-0 text-md-left text-center">
                <h1 id="titre">{{'Audit - Formation - Conseil QHSE' | translate}}</h1>
                <p class="mt-3">{{'Une méthodologie, véritable contrat d’efficacité' | translate}}</p>
                <div class="mb-3 mb-md-0 mt-4">
                    <button class="btn btn-immersive btn-rounded w-75" (click)="showModalContact()"><i class="fas fa-envelope mr-2"></i>{{'Nous contacter' | translate}}</button>
                </div>
        </div>
        <div class="col-md-8 col-12 my-5 my-md-0 pl-md-5 pl-0 text-md-right text-center">
                <picture>
                    <source srcset="assets/{{'echangeformation-header-fr' | translate}}.webp" type="image/webp">
                    <source srcset="assets/{{'echangeformation-header-fr' | translate}}.jpg" type="image/jpg">
                    <img src="assets/{{'echangeformation-header-fr' | translate}}.jpg" alt="The Echange Formation methodology" title="Audit - Training - QEHS - Consulting" loading="lazy"/>
                </picture>
        </div>
    </div>
</div>
</div>

<hr class="my-0 py-0">

      <div class="py-4 text-center d-flex align-items-center justify-content-center flex-wrap custom-gap">
        <ng-container *ngFor="let logo of certifications">
            <picture *ngIf="!logo.isSVG" class="logo-container">
                <source srcset="{{logo.src}}.webp" type="image/webp">
                <source srcset="{{logo.src}}.png" type="image/png">
                <img src="{{logo.src}}.png" alt="{{logo.alt}} logo" title="{{logo.title}}" [attr.width]="logo.width" loading="lazy"/>
            </picture>
            <img *ngIf="logo.isSVG" class="logo-container" src="{{logo.src}}.svg" alt="{{logo.alt}} logo" title="{{logo.title}}" [attr.width]="logo.width" loading="lazy"/>
        </ng-container>
      </div>

<hr class="my-0 py-0">

<div class="container my-5 pb-1">
    <div class="text-center mb-5 mt-0">
        <h2 class="title">{{'Qui est Echange Formation ?' | translate}}</h2>
        <p class="mt-5 text-justify-center">{{'Depuis 1989, Echange Formation met à votre disposition une équipe de professionnels formateurs consultants permanents, proches de vous, à votre écoute et toujours présents pour vous apporter leur expérience dans le domaine QHSE (Qualité, Hygiène, Sécurité, Environnement)' | translate}}.</p>
    </div>
    <hr class="my-5">
    <div class="row d-flex justify-content-center align-items-top">
      <div class="col-12 col-md-6 mb-md-0 mb-4 pr-md-4">
            <picture>
                <source srcset="assets/echangeformation-cpr.webp" type="image/webp">
                <source srcset="assets/echangeformation-cpr.jpg" type="image/jpg">
                <img src="assets/echangeformation-cpr.jpg" alt="A woman providing first-aid training" title="First-aid training" class="border-radius shadow mb-4 w-100" loading="lazy"/>
            </picture>
            <picture>
                <source srcset="assets/echangeformation-extincteur.webp" type="image/webp">
                <source srcset="assets/echangeformation-extincteur.jpg" type="image/jpg">
                <img src="assets/echangeformation-extincteur.jpg" alt="A man who raises staff awareness of fire prevention" title="Fire safety training" class="border-radius shadow w-100" loading="lazy"/>
            </picture>
        </div>
        <div class="col-12 col-md-6 mb-md-0 mb-4 text-justify pl-md-4">
            <p>{{'Nous vous proposons une réponse adaptée à vos besoins, des outils innovants pour évaluer vos performances et développer durablement les compétences de vos équipes. Partenaire actif, nous agissons pour l’amélioration de l’' | translate}}<span class="blue-text">{{'hygiène' | translate}}</span>, {{'la mise en place et le contrôle de votre' | translate}} <span class="blue-text">{{'système qualité' | translate}}</span>, {{'la préparation de votre personnel à la' | translate}} <span class="blue-text">certification</span>, {{'la maîtrise de l’' | translate}}<span class="blue-text">{{'accueil' | translate}}</span>, {{'la' | translate}} <span class="blue-text">communication</span>... {{'de la qualité au service des clients !' | translate}}</p>
            <p>{{'Notre équipe s’engage à prendre totalement en compte vos attentes : Analyse de votre problématique, définition claire de vos objectifs, intégration de votre environnement, de vos spécificités avec des' | translate}} <span class="blue-text">{{'prestations sur mesure' | translate}}</span>.</p>
            <p>{{'Nous nous engageons à être véritablement professionnelle et responsable : respect de la déontologie et de l’éthique, choix du formateur consultant en fonction de l’attente exprimée et de la nature de l’intervention,' | translate}} <span class="blue-text">{{'formation participative, pratique, constructive et pertinente' | translate}}</span>.</p>
        </div>
    </div>
</div>

<hr class="my-0 py-0">

<div class="container my-5">
    <div class="text-center mb-5 mt-0">
        <h2 class="title">{{'Nos caractéristiques' | translate}}</h2>
    </div>
    <div class="row d-flex justify-content-center align-items-top mb-4">
        <div class="col-12 col-md-6 pr-4 mb-md-0 mb-4 pt-1">
                <div class="d-flex mb-3">
                    <i class="fas fa-check-circle mr-1 custom-circle"></i>
                    <p class="mb-0 text-justify">
                        <span class="font-weight-bold">{{'Expertise connue' | translate}}</span> {{'et reconnue depuis 1989' | translate}}
                    </p>
                </div>
                <div class="d-flex mb-3">
                    <i class="fas fa-check-circle mr-1 custom-circle"></i>
                    <p class="mb-0 text-justify">
                        <span class="font-weight-bold">{{'Prestation sur mesure' | translate}}</span> {{'avec engineering de la formation QHSE, adaptation aux besoins de chaque site, de chaque service...' | translate}}
                    </p>
                </div>
                <div class="d-flex mb-2">
                    <i class="fas fa-check-circle mr-1 custom-circle"></i>
                    <p class="mb-0 text-justify">
                        <span class="font-weight-bold">{{'Qualité des formations :' | translate}}</span>
                    </p>
                </div>
                <ul>
                  <li class="mb-1"><span class="font-weight-bold">{{'Disponibilité' | translate}}</span> {{'des' | translate}} <span class="font-weight-bold">{{'formateurs permanents' | translate}}</span> {{'et' | translate}} <span class="font-weight-bold">{{'souplesse' | translate}}</span> {{'dans leurs interventions Formation-Action' | translate}}</li>
                  <li class="mb-1"><span class="font-weight-bold">{{'Résultats mesurables' | translate}}</span> {{'avec préconisations comprenant les points forts, les points faibles et les objectifs' | translate}}</li>
                  <li><span class="font-weight-bold">{{'Efficacité' | translate}}</span> {{'mesurable des formations' | translate}}</li>
                </ul>
                <div class="d-flex mb-2">
                    <i class="fas fa-check-circle mr-1 custom-circle"></i>
                    <p class="mb-0 text-justify">
                        <span class="font-weight-bold">{{'Service global :' | translate}}</span>
                    </p>
                </div>
                <ul>
                  <li class="mb-1">{{'Audit - Formation – Conseil' | translate}}</li>
                  <li><span class="font-weight-bold">{{'Outils brevetés' | translate}}</span> {{'(jeux, quiz, casque VR, etc..)' | translate}}</li>
                </ul>
        </div>
        <div class="col-12 col-md-6 mb-md-0 pl-4">
            <div class="videoContainer border-radius shadow">
              <video poster="https://immersivemisc.s3.eu-west-3.amazonaws.com/videos/posters/echangeformation-gif-poster.jpg" autoplay="autoplay" muted="muted" webkit-playsinline="true" playsinline="true" loop="loop" preload="auto">
                  <source src="https://immersivemisc.s3.eu-west-3.amazonaws.com/videos/echangeformation-gif.webm" type="video/webm">
                  <source src="https://immersivemisc.s3.eu-west-3.amazonaws.com/videos/echangeformation-gif.mp4" type="video/mp4">
              </video>
            </div>
        </div>
    </div>
      <div class="text-center my-3">
        <a class="btn btn-immersive btn-rounded px-5" (click)="showModalContact()" title="Learn more">
          {{'En savoir plus' | translate}}
        </a>
      </div>
</div>

<hr class="my-0 py-0">

<div class="grey-bg my-0">
    <div class="py-5">
        <div class="container text-center">
            <span class="title sub-bar">{{'Nos formations' | translate}}</span>
        </div>
        <div class="container mt-5">
            <div class="row all-cards text-justify-center">
                <div class="col-md-4 col-sm-6 mb-4">
                    <div class="full-w-h block-training p-4">
                        <span class="fa-stack fa-lg mb-3">
                          <i class="fas fa-circle fa-stack-2x icon-blue"></i>
                          <i class="fas fa-users fa-stack-1x fa-inverse"></i>
                        </span>
                            <p class="my-0"><span class="font-weight-bold">{{ 'Des interventions adaptées' | translate}}</span> {{'sur des sites de production de' | translate}} <span class="font-weight-bold">{{ 'moins de 10 à plus de 800 personnes' | translate}}</span></p>
                    </div>
                </div>
                <div class="col-md-4 col-sm-6 mb-4">
                    <div class="full-w-h block-training p-4">
                      <span class="fa-stack fa-lg mb-3">
                        <i class="fas fa-circle fa-stack-2x icon-blue"></i>
                        <i class="fas fa-graduation-cap fa-stack-1x fa-inverse"></i>
                      </span>
                            <p class="my-0"><span class="font-weight-bold">{{ 'Des formations sur mesure' | translate}}</span> {{'qui apportent des réponses adaptées aux besoins de chaque site, produisent du résultat et développent la motivation de l’ensemble des équipes' | translate}}</p>
                    </div>
                </div>
                <div class="col-md-4 col-sm-6 mb-4">
                    <div class="full-w-h block-training p-4">
                        <span class="fa-stack fa-lg mb-3">
                          <i class="fas fa-circle fa-stack-2x icon-blue"></i>
                          <i class="fas fa-list-ul fa-stack-1x fa-inverse"></i>
                        </span>
                            <p class="my-0"><span class="font-weight-bold">{{ 'Sujets :' | translate}}</span> {{'Hygiène - Qualité - Sécurité Sanitaire des aliments (PMS, HACCP, ISO 22000, etc..), Santé - Sécurité - Environnement - QSE (CSE / CSSCT, Iso 50001 / 14001, DUERP, etc..), Formation métiers Agroalimentaire (CQP), Management - Communication – Motivation' | translate}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<hr class="my-0 py-0">

<div class="container my-5 pb-1">
  <div class="text-center mb-4 mt-0">
      <h2 class="title">{{'Catalogue de formations' | translate}}</h2>
  </div>
  <div class="img-container position-relative">
    <picture>
        <source srcset="assets/{{'echangeformation-catalogue-fr' | translate}}.webp" type="image/webp">
        <source srcset="assets/{{'echangeformation-catalogue-fr' | translate}}.jpg" type="image/jpg">
        <img src="assets/{{'echangeformation-catalogue-fr' | translate}}.jpg" alt="Training catalog from Echange Formation" title="Echange Formation catalog" class="border-radius shadow w-100 my-2 fade-animation" loading="lazy"/>
    </picture>
    <div class="img-text">
      <a class="btn btn-immersive ef-catalog-btn px-md-5 px-2" href="https://communication.immersivefactory.com/catalogue-echangeformation-2025-2026-fr.pdf" target="_blank" rel="noopener nofollow" title="Download">
        <i class="fas fa-download mr-2"></i>{{'Télécharger' | translate}}
      </a>
    </div>
  </div>
  <div class="mt-4 d-flex justify-content-center align-items-center">
      <a class="btn btn-immersive ef-catalog-btn px-md-5 px-2 mr-4" (click)="showModalContact()" title="Book your training">
        <i class="fas fa-calendar-check mr-2"></i><span>{{'Réserver sa formation QHSE' | translate}}</span>
      </a>
      <a class="btn btn-immersive ef-catalog-btn px-md-5 px-2" href="https://communication.immersivefactory.com/catalogue-echangeformation-2025-2026-fr.pdf" target="_blank" rel="noopener nofollow" title="Download catalogue">
        <i class="fas fa-download mr-2"></i>{{'Télécharger le catalogue 2025 - 2026' | translate}}
      </a>
  </div>
</div>

<hr class="m-0 p-0">

<!-- <div class="container my-5 pb-1">
  <div class="text-center mb-4 mt-0">
      <h2 class="title">{{'Catalogue OCAPIAT' | translate}}</h2>
  </div>
  <picture>
      <source srcset="assets/{{'ocapiat-catalogue-fr' | translate}}.webp" type="image/webp">
      <source srcset="assets/{{'ocapiat-catalogue-fr' | translate}}.jpg" type="image/jpg">
      <img src="assets/{{'ocapiat-catalogue-fr' | translate}}.jpg" alt="Training catalog from OCAPIAT" title="OCAPIAT catalog" class="border-radius shadow w-100 my-2" loading="lazy"/>
  </picture>
  <div class="mt-4 d-flex justify-content-center align-items-center">
      <a class="btn btn-immersive btn-rounded px-5" href="https://www.ocapiat.fr/catalogue-de-formations-et-financement/" target="_blank" rel="noopener nofollow" title="OCAPIAT catalog">
        <i class="fas fa-download mr-2"></i>{{'Télécharger le catalogue OCAPIAT' | translate}}
      </a>
  </div>
</div>

<hr class="m-0 p-0"> -->

<div class="container py-5 mb-4">
  <div class="text-center mb-5 mt-0">
      <h2 class="title">{{'Les exclusivités Echange Formation' | translate}}</h2>
  </div>
  <div class="row d-flex justify-content-center align-items-top pb-1 mb-md-4 mb-1">
      <div class="col-12 col-md-6 pr-md-4 pl-md-0 px-3 pt-2 mb-md-0 mb-4">
                <div class="d-flex mb-3">
                    <i class="fas fa-check-circle mr-1 custom-circle"></i>
                    <p class="mb-0 text-justify">
                        <span class="font-weight-bold">{{'Accompagnement' | translate}}</span>{{' solide, engagement adapté sur chaque site, progrès tangibles et mesurés - Formations évaluées à chauds et à froids' | translate}}
                    </p>
                </div>
                <div class="d-flex mb-2">
                    <i class="fas fa-check-circle mr-1 custom-circle"></i>
                    <p class="mb-0 text-justify">
                        <span class="font-weight-bold">{{'Des outils brevetés, novateurs et innovants :' | translate}}</span> {{'Pack Evolution, Prog’Sécur, Prog’Eco Environnement. Ces outils ont fait leurs preuves et donnent satisfaction à tous leurs utilisateurs' | translate}}
                    </p>
                </div>
                <ul>
                  <li class="mb-1">{{'Ils sont sans cesse renouvelés dans leur concept et répondent à un besoin de' | translate}} <span class="font-weight-bold">{{'modernité et d’évolution permanente' | translate}}</span></li>
                  <li>{{'Adaptés sur mesure aux sites sur lesquels ils sont en place' | translate}}</li>
                </ul>
        </div>
      <div class="col-12 col-md-6 mb-md-0 pl-md-4 pr-md-0 px-3">
          <picture>
              <source srcset="assets/echangeformation-jeu-societe.webp" type="image/webp">
              <source srcset="assets/echangeformation-jeu-societe.jpg" type="image/jpg">
              <img src="assets/echangeformation-jeu-societe.jpg" alt="Collaborators playing a board game on workplace safety" title="Board game" class="border-radius shadow mb-3 w-100" loading="lazy"/>
          </picture>
      </div>
  </div>
  <div class="row d-flex justify-content-center align-items-top">
      <div class="col-12 col-md-6 mb-md-0 mb-4 pr-md-4 pl-md-0 px-3">
          <picture>
              <source srcset="assets/echangeformation-equipe.webp" type="image/webp">
              <source srcset="assets/echangeformation-equipe.jpg" type="image/jpg">
              <img src="assets/echangeformation-equipe.jpg" alt="All Echange Formation collaborators" title="Echange Formation team" class="border-radius shadow w-100" loading="lazy"/>
          </picture>
      </div>
      <div class="col-12 col-md-6 pl-md-4 pr-md-0 px-3">
        <div class="d-flex mb-3">
            <i class="fas fa-check-circle mr-1 custom-circle"></i>
            <p class="mb-0 text-justify">
                <span class="font-weight-bold">{{'Mise en place d’indicateurs' | translate}}</span> {{'qui sont un réel outil qualité offrant une vision extérieure indépendante, neutre et indispensable au responsable Qualité/sécurité et à l’encadrement afin de' | translate}} <span class="font-weight-bold">{{'lutter contre l’habitude et la lassitude' | translate}}</span>
            </p>
        </div>
        <div class="d-flex mb-3">
            <i class="fas fa-check-circle mr-1 custom-circle"></i>
            <p class="mb-0 text-justify">
                <span class="font-weight-bold">{{'Souplesse des interventions' | translate}}</span> {{'auprès des équipes selon leurs horaires de travail y compris en horaires décalés' | translate}}
            </p>
        </div>
        <div class="d-flex mb-3">
            <i class="fas fa-check-circle mr-1 custom-circle"></i>
            <p class="mb-0 text-justify">
                {{'Disponibilité : Echange Formation, entreprise nationale qui' | translate}} <span class="font-weight-bold">{{'intervient sur toutes les régions de France' | translate}}</span>
            </p>
        </div>
      </div>
  </div>
</div>


<hr class="my-0 py-0">


<div class="grey-bg my-0">
    <div class="py-5">
        <div class="container text-center">
            <span class="title sub-bar">{{'Nos indicateurs Qualité' | translate}}</span>
        </div>
        <div class="container mt-5">
            <div class="row all-cards text-justify-center">
                <div class="col-md-6 col-sm-12 mb-4">
                    <div class="full-w-h block-training p-5">
                      <div class="min-h d-flex justify-content-center align-items-center">
                        <picture>
                            <source srcset="assets/{{'ef-indicateur-qualite-1' | translate}}.webp" type="image/webp">
                            <source srcset="assets/{{'ef-indicateur-qualite-1' | translate}}.png" type="image/png">
                            <img src="assets/{{'ef-indicateur-qualite-1' | translate}}.png" width="87" class="mb-4" alt="Trainees celebrate their CQP exams" title="Passing the CQP exam" loading="lazy"/>
                        </picture>
                      </div>
                      <p class="my-0">{{'De 2010 à fin 2024' | translate}}, <span class="blue-text">{{'100% des stagiaires' | translate}}</span> {{'qui se sont présentés à l’examen CQP avec Echange Formation l’ont obtenu' | translate}}</p>
                    </div>
                </div>
                <div class="col-md-6 col-sm-12 mb-4">
                    <div class="full-w-h block-training p-5">
                      <div class="min-h d-flex justify-content-center align-items-center">
                        <picture>
                            <source srcset="assets/{{'ef-indicateur-qualite-2' | translate}}.webp" type="image/webp">
                            <source srcset="assets/{{'ef-indicateur-qualite-2' | translate}}.png" type="image/png">
                            <img src="assets/{{'ef-indicateur-qualite-2' | translate}}.png" width="75" class="mb-4" alt="Our customers recommend Echange Formation" title="Recommendation of Echange Formation" loading="lazy"/>
                        </picture>
                      </div>
                      <p class="my-0">{{'Sur les 11 dernières années' | translate}}, <span class="blue-text">{{'100% de nos clients' | translate}}</span> {{'ont répondu oui à la question : « recommanderiez-vous notre organisme à vos relations professionnelles ? »' | translate}}</p>
                    </div>
                </div>
                <div class="col-md-6 col-sm-12 mb-4">
                    <div class="full-w-h block-training p-5">
                      <div class="min-h d-flex justify-content-center align-items-center">
                        <picture>
                            <source srcset="assets/{{'ef-indicateur-qualite-3' | translate}}.webp" type="image/webp">
                            <source srcset="assets/{{'ef-indicateur-qualite-3' | translate}}.png" type="image/png">
                            <img src="assets/{{'ef-indicateur-qualite-3' | translate}}.png" width="145" class="mb-4" alt="Echange Formation training ratings" title="High-quality training from Echange Formation" loading="lazy"/>
                        </picture>
                      </div>
                      <p class="my-0">{{'En 2024, la qualité de nos formations a été évaluée par les donneurs d’ordres avec une moyenne de' | translate}} <span class="blue-text">{{'9,73 sur 10' | translate}}</span></p>
                    </div>
                </div>
                <div class="col-md-6 col-sm-12 mb-4">
                    <div class="full-w-h block-training p-5">
                      <div class="min-h d-flex justify-content-center align-items-center">
                        <picture>
                            <source srcset="assets/{{'ef-indicateur-qualite-4' | translate}}.webp" type="image/webp">
                            <source srcset="assets/{{'ef-indicateur-qualite-4' | translate}}.png" type="image/png">
                            <img src="assets/{{'ef-indicateur-qualite-4' | translate}}.png" width="170" class="mb-4" alt="Quality assessment of Echange Formation's training courses" title="Excellent quality of Echange Formation's training courses" loading="lazy"/>
                        </picture>
                      </div>
                      <p class="my-0">{{'Sur l’année 2024, la Qualité de nos formations a été évaluée comme excellente par les stagiaires avec une note de' | translate}} <span class="blue-text">{{'92,18 sur 100' | translate}}</span></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<hr class="m-0 p-0">


<div class="container my-5">
  <div class="text-center mb-5 mt-0">
      <h2 class="title">{{'Nos engagements Qualité 2025/2026' | translate}}</h2>
  </div>
  <div class="col-12 mb-5 pb-3">
    <p class="text-justify">{{'Notre politique de progrès continu : atteindre l’excellence dans nos actions et contacts avec chaque client et partenaire. Dans ce but, notre démarche Qualité place nos clients au centre de nos priorités. À cette fin, nous avons mis en place :' | translate}}</p>
    <div class="d-flex mb-3">
        <i class="fas fa-check-circle mr-2 custom-circle"></i>
        <p class="mb-0 text-justify">
          {{'Une équipe de consultants formateurs permanents qualifiés. Chaque consultant formateur est concepteur des offres de formation pour lesquelles il est qualifié. Il est disponible directement sur son portable et s’engage à répondre téléphoniquement dans les 48 heures à toute demande ou à toute sollicitation concernant l’offre de formation' | translate}}
        </p>
    </div>
    <div class="d-flex mb-3">
        <i class="fas fa-check-circle mr-2 custom-circle"></i>
        <p class="mb-0 text-justify">
          {{'Un accueil téléphonique est assuré du lundi au vendredi de 8H à 18H, avec un engagement à ce que chaque demande de nos clients soit traitée dans un délai maximum de 7 jours' | translate}}
        </p>
    </div>
    <div class="d-flex mb-3">
        <i class="fas fa-check-circle mr-2 custom-circle"></i>
        <p class="mb-0 text-justify">
          {{'Pour nos formations en intra, nous réalisons des actions sur mesure, adaptées aux attentes de nos clients. Chaque formateur agit pour concrétiser les résultats définis lors de l’analyse' | translate}}
        </p>
    </div>
    <div class="d-flex mb-3">
        <i class="fas fa-check-circle mr-2 custom-circle"></i>
        <p class="mb-0 text-justify">
          {{'À chaque intervention d’accompagnement, un compte-rendu est systématiquement réalisé, présenté, commenté aux participants et au référent de l’action. Des objectifs sont définis et validés avec les équipes durant toute l’action de formation afin d’être en parfaite adéquation avec le programme pédagogique' | translate}}
        </p>
    </div>
    <div class="d-flex">
        <i class="fas fa-check-circle mr-2 custom-circle"></i>
        <p class="mb-0 text-justify">
          {{'Une enquête de satisfaction « PACTE » à froid est envoyée par courrier au donneur d’ordre maximum 30 jours après la formation. À son retour, elle est analysée en profondeur et constitue un indicateur de performance de notre stratégie Qualité. Chaque évaluation comportant une note en dessous de 6 déclenche un appel de la Direction auprès du client afin de connaître les causes de la non-conformité. De là, sont mises en place une ou des actions correctives' | translate}}
        </p>
    </div>
    <!-- <div class="py-3">
      <hr>
    </div>
    <div class="d-flex flex-column-reverse flex-sm-row justify-content-center justify-content-sm-between align-items-top">
      <div class="d-flex justify-content-center justify-content-sm-start align-items-center text-center text-sm-left">
        <div class="mr-4"><span class="blue-text">Olivier PIERRE</span><br>{{'Président' | translate}}</div>
        <div class="ml-4"><span class="blue-text">Noël CHOMEL</span><br>{{'Directeur Echange Formation' | translate}}</div>
      </div>
      <p class="text-center text-sm-left mb-4 mb-sm-0">{{'Fait à St Chamond le 06 janvier 2025' | translate}}</p>
    </div> -->
  </div>
</div>


  <hr class="m-0 mb-4 p-0">


  <div class="container my-5">
    <div class="text-center mb-5 mt-0">
        <h2 class="title">{{'Contactez-nous' | translate}}</h2>
    </div>
    <div class="col-12 border-radius block-contact blue-bg p-5 text-justify-center mb-5">
      <p>{{'Notre équipe dynamique d’assistants présente au Siège Social est à votre écoute 5 jours sur 7 de 8h à 18h et est prête à répondre immédiatement à toutes vos questions' | translate}}</p>
      <div class="mt-4">
          <button class="btn btn-immersive btn-rounded px-5" (click)="showModalContact()"><i class="fas fa-envelope mr-2"></i>{{'Nous contacter' | translate}}</button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-12 pb-md-0 pb-4 border-contact">
        <div class="d-flex align-items-center mb-3">
          <span class="fa-stack mr-2">
            <i class="fas fa-circle fa-stack-2x icon-blue"></i>
            <i class="fas fa-map-marker-alt fa-stack-1x fa-inverse"></i>
          </span>
          <span class="text-uppercase blue-text">{{'Adresse' | translate}}</span>
        </div>
        <p class="pl-1 mb-0">3 avenue Antoine Pinay<br>42400 ST-CHAMOND (LOIRE)</p>
      </div>
      <div class="col-md-4 col-12 pb-md-0 pb-4 pt-md-0 pt-4 pl-md-5 pr-md-0 px-3 border-contact">
        <div class="d-flex align-items-center mb-3">
          <span class="fa-stack mr-2">
            <i class="fas fa-circle fa-stack-2x icon-blue"></i>
            <i class="fas fa-phone-alt fa-stack-1x fa-inverse"></i>
          </span>
          <span class="text-uppercase blue-text">{{'Téléphone' | translate}}</span>
        </div>
        <p class="pl-1 mb-0">04 77 31 90 23</p>
      </div>
      <div class="col-md-4 col-12 pl-md-5 pt-md-0 pt-4 pr-md-0 px-3">
        <div class="d-flex align-items-center mb-3">
          <span class="fa-stack mr-2">
            <i class="fas fa-circle fa-stack-2x icon-blue"></i>
            <i class="fas fa-fax fa-stack-1x fa-inverse"></i>
          </span>
          <span class="text-uppercase blue-text">Fax</span>
        </div>
        <p class="pl-1 mb-0">04 77 31 33 26</p>
      </div>
    </div>
  </div>


  <!-- MODALE -->
  <div class="modal fade" tabindex="-1" role="dialog" id="contact-modal" aria-labelledby="contactModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="container">
            <div class="row">
              <div class="col-xl-5 col-lg-6 col-12 img-banner">
                <div class="blue-background">
                  <div class="infos-content d-flex flex-column justify-content-between py-4 px-custom h-custom">
                    <div class="d-lg-block d-none">
                      <h5 class="font-weight-bold">{{'Entrons en contact' | translate}}</h5>
                    </div>
                    <div class="d-lg-none d-block d-flex align-items-start justify-content-between">
                      <h5 class="font-weight-bold pr-2">{{'Entrons en contact, nous vous rappellerons dans les plus brefs délais' | translate}}</h5>
                      <button type="button" class="close" (click)="hideModalContact()">
                          <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="d-flex align-items-center mb-lg-0 mb-2">
                      <app-svg-icon [src]="'assets/svg/envelope-light.svg'" [size]="'50px'" class="fas d-lg-block d-none contact-icon mr-4"></app-svg-icon>
                      <app-svg-icon [src]="'assets/svg/envelope-light.svg'" [size]="'25px'" class="fas d-lg-none d-block contact-icon mr-3"></app-svg-icon>
                      <div class="d-lg-block d-none">{{'Pour toutes demandes commerciales, remplissez le formulaire ci-contre' | translate}} <i class="ml-1 fas fa-long-arrow-alt-right fa-lg"></i></div>
                      <div class="d-lg-none d-block">{{'Pour toutes demandes commerciales, remplissez le formulaire ci-dessous' | translate}}</div>
                    </div>
                    <div class="d-flex align-items-center mb-lg-0 mb-2">
                      <app-svg-icon [src]="'assets/svg/comment-dots-light.svg'" [size]="'50px'" class="fas d-lg-block d-none contact-icon mr-4"></app-svg-icon>
                      <app-svg-icon [src]="'assets/svg/comment-dots-light.svg'" [size]="'25px'" class="fas d-lg-none d-block contact-icon mr-3"></app-svg-icon>
                      <div>
                          <span class="mr-2">{{'Pour toutes autres demandes' | translate}}</span>
                          <div class="bg-immersive btn-chat-with-us woot-widget-bubble woot-widget--expanded__text mt-1" (click)="openChat()">
                              {{'Discuter avec nous' | translate}}
                          </div>
                      </div>
                    </div>
                    <!-- <div class="d-flex align-items-center">
                      <app-svg-icon [src]="'assets/svg/briefcase-light.svg'" [size]="'50px'" class="fas d-lg-block d-none contact-icon mr-4"></app-svg-icon>
                      <app-svg-icon [src]="'assets/svg/briefcase-light.svg'" [size]="'25px'" class="fas d-lg-none d-block contact-icon mr-3"></app-svg-icon>
                      <div>{{'Pour postuler, rendez-vous' | translate}} <span class="url" [routerLink]="language.navigateAccordingToLang(['/jobs'])">{{'sur cette page' | translate}}</span></div>
                    </div> -->
                  </div>
                </div>
              </div>
              <div class="modal-content col-xl-7 col-lg-6 col-12">
                  <div class="modal-header border-0">
                      <h5 class="modal-title" id="contactModalLabel">{{'Laissez-nous vos coordonnées' | translate}}</h5>
                      <button type="button" class="close d-lg-block d-none" (click)="hideModalContact()">
                          <span aria-hidden="true">&times;</span>
                      </button>
                  </div>
                  <div class="modal-body px-3 pb-3 pt-0">
                      <contact-form
                          (formSuccess)="hideModalContact()"
                          [prefillFields]="prefillFields"
                          [formId]="'contact'"
                          [removeFields]="contactFormHiddenInputs"
                          [messageFillPropositions]="messageFillPropositions"
                          [autoFill]="true"
                          *ngIf="modalIsOpen()"
                      ></contact-form>
                  </div>
              </div>
            </div>
          </div>
      </div>
  </div>
